var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 2.61926V6.06138C11.6666 6.52809 11.6666 6.76144 11.7574 6.9397C11.8373 7.09651 11.9648 7.22399 12.1216 7.30388C12.2999 7.39471 12.5332 7.39471 12.9999 7.39471H16.442M13.3333 11.5613H6.66659M13.3333 14.8947H6.66659M8.33325 8.22799H6.66659M11.6666 2.39465H7.33325C5.93312 2.39465 5.23306 2.39465 4.69828 2.66714C4.22787 2.90682 3.84542 3.28927 3.60574 3.75968C3.33325 4.29446 3.33325 4.99452 3.33325 6.39465V15.0613C3.33325 16.4615 3.33325 17.1615 3.60574 17.6963C3.84542 18.1667 4.22787 18.5492 4.69828 18.7888C5.23306 19.0613 5.93312 19.0613 7.33325 19.0613H12.6666C14.0667 19.0613 14.7668 19.0613 15.3016 18.7888C15.772 18.5492 16.1544 18.1667 16.3941 17.6963C16.6666 17.1615 16.6666 16.4615 16.6666 15.0613V7.39465L11.6666 2.39465Z",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.d8ec5c67cc28ec10ba6a6899a5e88388.svg";
export { ForwardRef as ReactComponent };